const themeColors = {
  darkGray: "hsl(0, 0%, 59%)",
  veryDarkGray: "hsl(0, 0%, 17%)",
  white: "#fff",
};

export { themeColors };
